import {
    AvailableAddonType,
    AnyUpsellAddon,
    UpSellAddonSeating,
} from '@/api/MyBookingSession/myBookingSession.interfaces';
import { generateUUID } from '@shared/utils/uuid';
import { SeatAvailability } from '@/api/Cart/cart.interfaces';

export const mapAvailableAddons = (addons: AnyUpsellAddon[]) => {
    const addonsToExclude: AvailableAddonType[] = [];
    const shouldExcludeSeating = (
        addons.filter(
            (addon) => addon.Type === AvailableAddonType.Seating
        ) as UpSellAddonSeating[]
    ).every(
        (addon: UpSellAddonSeating) =>
            addon.GordianSession.SeatAvailability === SeatAvailability.NotAvailable
    );
    if (shouldExcludeSeating) {
        addonsToExclude.push(AvailableAddonType.Seating);
    }

    return addons
        .map((addon) => ({
            ...addon,
            Id: addon.Id ?? generateUUID(),
            Status: undefined,
        }))
        .filter((addon) => !addonsToExclude.includes(addon.Type));
};
